;(function () {
  // Alia SDK event names. "popupView" is the actual display event; we use it
  // (not "campaignMatched", which only means targeting was matched and does
  // not guarantee the popup rendered) so opens/dismissals reflect real views.
  const ALIA_EVENTS = {
    opened: "alia:popupView",
    signup: "alia:signup",
    closed: "alia:popupClose",
  };

  const IG_EVENTS = {
    opened: "alia_popup_opened",
    submitted: "alia_popup_email_submitted",
    phoneSubmitted: "alia_popup_phone_submitted",
    dismissed: "alia_popup_dismissed",
  };

  function readConfig() {
    const node = document.getElementById("ig-alia-config");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (error) {
      return null; // Malformed config: bail out.
    }
  }

  function pushEvent(name) {
    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event: name });
  }

  function init() {
    const config = readConfig();
    if (!config) return;

    const variants = Array.isArray(config.variants) ? config.variants : [];
    const allowedPopupIds = new Set();
    variants.forEach((variant) => {
      if (variant && variant.popupId != null) {
        allowedPopupIds.add(String(variant.popupId));
      }
    });

    if (allowedPopupIds.size === 0) return;

    const state = new Map(); // popupId -> { emailSubmitted: boolean, phoneSubmitted: boolean }

    function popupIdFor(event) {
      const popupId = event.detail && event.detail.popupID;
      if (popupId == null) return null;
      const key = String(popupId);
      return allowedPopupIds.has(key) ? key : null;
    }

    document.addEventListener(ALIA_EVENTS.opened, (event) => {
      const popupId = popupIdFor(event);
      if (!popupId) return;
      state.set(popupId, { emailSubmitted: false, phoneSubmitted: false });
      pushEvent(IG_EVENTS.opened);
    });

    document.addEventListener(ALIA_EVENTS.signup, (event) => {
      const popupId = popupIdFor(event);
      if (!popupId) return;
      const entry = state.get(popupId);
      if (!entry) return; // Signup with no open we tracked — ignore.

      // Alia fires "alia:signup" once per step of a multi-step popup. Step 1
      // submits the email (detail has `email` only); step 2 submits the phone
      // (detail carries both `email` and `phone`). We branch on phone presence
      // and gate each step in memory so neither double-fires in one open cycle.
      const detail = event.detail || {};
      const hasPhone = detail.phone != null && String(detail.phone).trim() !== "";
      const hasEmail = detail.email != null && String(detail.email).trim() !== "";

      if (hasPhone) {
        if (entry.phoneSubmitted) return;
        entry.phoneSubmitted = true;
        pushEvent(IG_EVENTS.phoneSubmitted);
      } else if (hasEmail) {
        if (entry.emailSubmitted) return;
        entry.emailSubmitted = true;
        pushEvent(IG_EVENTS.submitted);
      }
    });

    document.addEventListener(ALIA_EVENTS.closed, (event) => {
      const popupId = popupIdFor(event);
      if (!popupId) return;
      const entry = state.get(popupId);
      // Dismissed = closed after an open we tracked with nothing submitted —
      // neither the email step nor the phone step fired.
      if (entry && !entry.emailSubmitted && !entry.phoneSubmitted) {
        pushEvent(IG_EVENTS.dismissed);
      }
      // Clear so a re-open starts a fresh cycle.
      state.delete(popupId);
    });
  }

  init();
})();
